import React from 'react'
import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const useStyles = makeStyles({
  root: {
    textTransform: 'initial',
    fontWeight: 'normal',
    padding: 0,
    '&:hover': {
      textDecoration: 'underline',
      background: 'none'
    }
  }
})

const Link = props => {
  const { children, className, to, newTab, ...rest } = props

  const classes = useStyles()

  return (
    <Button
      {...rest}
      className={clsx(className, classes.root)}
      size='small'
      onClick={() => {
        !newTab ? (window.location.href = to) : window.open(to, '_blank')
      }}
    >
      {children}
    </Button>
  )
}

Link.propTypes = {
  /** The content of the link. **/
  children: PropTypes.any.isRequired,
  /** Override or extend the styles applied to the component **/
  className: PropTypes.any
}

export default Link
